import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesOrdemCronologicaPagamentoInicio: [],
    buscaDetalhesOrdemCronologicaPagamentoSucesso: ['detalhesOrdemCronologicaPagamento'],
    buscaDetalhesOrdemCronologicaPagamentoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
}

const buscaDetalhesOrdemCronologicaPagamentoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDetalhesOrdemCronologicaPagamentoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDetalhesOrdemCronologicaPagamentoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.detalhesOrdemCronologicaPagamento, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_ORDEM_CRONOLOGICA_PAGAMENTO_INICIO]: buscaDetalhesOrdemCronologicaPagamentoInicio,
    [Types.BUSCA_DETALHES_ORDEM_CRONOLOGICA_PAGAMENTO_ERRO]: buscaDetalhesOrdemCronologicaPagamentoErro,
    [Types.BUSCA_DETALHES_ORDEM_CRONOLOGICA_PAGAMENTO_SUCESSO]: buscaDetalhesOrdemCronologicaPagamentoSucesso,
})
